import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { profile } from '../../data/profile';
import { ui } from '../../data/ui';
import './Navbar.css';

const navLinks = [
  { to: '/', label: ui.nav.home },
  { to: '/experience', label: ui.nav.experience },
  { to: '/projects', label: ui.nav.projects },
  { to: '/services', label: ui.nav.services },
  { to: '/certifications', label: ui.nav.certifications },
  { to: '/resume', label: ui.nav.resume },
  { to: '/contact', label: ui.nav.contact },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container navbar-inner">
        <Link to="/" className="navbar-logo">
          <span className="logo-accent">ماهر</span>
          <span className="logo-text"> ملحم</span>
        </Link>

        <div className="navbar-links">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`nav-link ${location.pathname === link.to ? 'nav-link-active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <Link to="/contact" className="btn btn-primary navbar-cta">
          {ui.nav.contact}
        </Link>

        <button
          type="button"
          className={`menu-toggle ${menuOpen ? 'menu-toggle-open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={ui.nav.toggleMenu}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`mobile-menu ${menuOpen ? 'mobile-menu-open' : ''}`}>
        <div className="mobile-menu-content">
          {navLinks.map((link, i) => (
            <Link
              key={link.to}
              to={link.to}
              className={`mobile-nav-link ${location.pathname === link.to ? 'mobile-nav-link-active' : ''}`}
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              {link.label}
            </Link>
          ))}
          <Link to="/contact" className="btn btn-primary mobile-cta">
            {ui.nav.contactMe}
          </Link>
        </div>
      </div>
    </nav>
  );
}
